import { render, staticRenderFns } from "./DBuilderCategoryPopup.vue?vue&type=template&id=4a311b74&scoped=true&"
import script from "./DBuilderCategoryPopup.vue?vue&type=script&lang=js&"
export * from "./DBuilderCategoryPopup.vue?vue&type=script&lang=js&"
import style0 from "./DBuilderCategoryPopup.vue?vue&type=style&index=0&id=4a311b74&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a311b74",
  null
  
)

export default component.exports